export default __webpack_public_path__ + "locales/pt-BR/Settings.json?hash=b72fed513d390656ab4b013f8598c74a";